export default __webpack_public_path__ + "static/media/MDHitech-controls.a8bbce02.md";